import api from "../axios";

export interface PaymentMethodSummary {
  id: number;
  uuid: string;
  type: string;
  last4: string | null;
  brand: string | null;
  expMonth: number | null;
  expYear: number | null;
  bankName: string | null;
  accountType: string | null;
  isDefault: boolean;
  createdAt: string;
  /** Bank account (us_bank_account) with no ACH mandate yet — needs re-auth. */
  requiresMandate: boolean;
}

export function getPaymentMethods() {
  return api.get<PaymentMethodSummary[]>("/payment-methods");
}

export function createCardSetupIntent() {
  return api.post<{ clientSecret: string; customerId: string }>(
    "/payment-methods/setup-intent",
  );
}

export function saveCardPaymentMethod(stripePaymentMethodId: string) {
  return api.post<PaymentMethodSummary>("/payment-methods/save-card", {
    stripePaymentMethodId,
  });
}

export function setDefaultPaymentMethod(id: number) {
  return api.post<PaymentMethodSummary>(`/payment-methods/${id}/default`);
}

export function deletePaymentMethod(id: number) {
  return api.delete<{ success: boolean }>(`/payment-methods/${id}`);
}

/**
 * Authorize ACH (add a mandate) for an existing bank account that lacks one.
 * `mandateAccepted` must be true — the tenant confirmed the disclosure.
 */
export function addBankMandate(id: number, mandateAccepted: boolean) {
  return api.post<PaymentMethodSummary>(
    `/payment-methods/${id}/add-mandate`,
    { mandateAccepted },
  );
}
